import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAttentionObservationsById } from "components/axios/equipmentAlertsAxios";
import Error404 from "pages/Error404";
import { useQuery } from "@tanstack/react-query";
import EquipmentAlertViewMonitoringPage from "components/inner/EquipmentAlertViewMonitoringPage";

const EquipmentObserveViewMaintenance = () => {

    const {id} = useParams();   // attentionObservation.id

    const [notFound, setNotFound] = useState(false);
    
    useEffect(() => {
        setNotFound(false);
    }, [id]);

    const { 
        data : info, 
    } = useQuery({
        queryKey: ['equipment-iot-view-base', id],

        queryFn: () => getAttentionObservationsById(id),

        // 깜빡임 방지
        placeholderData: previousData => previousData,

        refetchOnWindowFocus: false,
        refetchOnReconnect: false,

        enabled: !!id,
        retry: false,
        onError: (error) => {
            if (error?.response?.status === 404) {
                setNotFound(true);
            }
        }
    });
    
    if (notFound) {
        return <Error404 />
    }
    
    if (info?.equipmentAlert?.id) {
        return (
        <EquipmentAlertViewMonitoringPage alertId={info?.equipmentAlert?.id}/>
        )
    }
}

export default EquipmentObserveViewMaintenance;